import { connect, MapStateToProps } from 'react-redux';
import { getProfileOwnerUser } from '../../../selectors/users';
import { getShopItemsStreamId } from '../../../streams/shop';
import { ShopItemType } from '../../../../types/shop';
import { AppState } from '../../../../types/store';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { Props } from './ShopSection';

type StateProps = Pick<Props, 'profileOwnerUser' | 'total'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> =
  state => {
    const commissionsTotal = streamSelectors.getTotal(
      state,
      getShopItemsStreamId(ShopItemType.COMMISSIONS)
    );
    const premiumContentTotal = streamSelectors.getTotal(
      state,
      getShopItemsStreamId(ShopItemType.PREMIUM_CONTENT)
    );
    const printsTotal = streamSelectors.getTotal(
      state,
      getShopItemsStreamId(ShopItemType.PRINTS)
    );
    const premiumFoldersTotal = streamSelectors.getTotal(
      state,
      getShopItemsStreamId(ShopItemType.PREMIUM_FOLDERS)
    );
    const dasTotal = streamSelectors.getTotal(
      state,
      getShopItemsStreamId(ShopItemType.DAS)
    );

    const allTotal =
      commissionsTotal +
      premiumContentTotal +
      printsTotal +
      premiumFoldersTotal +
      dasTotal;

    return {
      profileOwnerUser: getProfileOwnerUser(state),
      total: {
        all: isNaN(allTotal) ? 0 : allTotal,
        commissions: commissionsTotal,
        premiumContent: premiumContentTotal,
        prints: printsTotal,
        premiumFolders: premiumFoldersTotal,
        das: dasTotal,
      },
    };
  };

export default connect(mapStateToProps);
